import { processDepartment } from './processDepartment';

/**
 *
 * @param {ADDDepartment[]} departments - Array of departments to process
 * @param {WidgetLocation} defaultLocation - Default location for fallbacks
 * @param {ADDContactInformation} primaryContactInformation - Primary contact information for fallbacks
 * @returns {WidgetLocation[]} Array of processed department locations
 */
export const buildDeptLocation = (
	departments,
	defaultLocation,
	primaryContactInformation
) => {
	const addresses = [defaultLocation];

	if (!departments || departments.length === 0) {
		return addresses;
	}

	// Process each department
	departments.forEach((department) => {
		processDepartment(
			department,
			addresses,
			defaultLocation,
			primaryContactInformation
		);
	});

	return addresses;
};
